import { Tooltip, Typography } from '@mui/material';
import React from 'react';
// import Dashboard from 'types/entities/Dashboard';

type ContentCellProps = {
  content?: string | null | undefined;
};

const Content = React.memo((row: ContentCellProps) => {
  if (!row?.content) return null;

  return (
    <Tooltip title={row?.content}>
      <Typography variant="body2" noWrap>
        {row?.content}
      </Typography>
    </Tooltip>
  );
});

export default Content;
